import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/offer';
export function SocialProof() {
  return <section className="w-full bg-carbon-900 py-16 sm:py-20 lg:py-28" aria-labelledby="proof-heading" data-id="element-191" data-mp="36vlhvrxutvob">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-192" data-mp="3btvapvw3wk6r">
        <SectionHeading id="proof-heading" eyebrow="Verified buyers" title="What the people who already bought it say" subtitle="Coaches, teachers, and runners using the PDFs on the track every week." data-id="element-193" data-mp="3bwhsspgmii38" />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:mt-14 sm:gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-194" data-mp="3ptek0s0nm1kn">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-xl border border-carbon-line bg-carbon-800 p-7" data-id="element-195" data-mp="3ur6cbn57nppd">
              <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-196" data-mp="r5qt5g93qvfm">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-mint text-mint" aria-hidden="true" data-id="element-197" data-mp="1pb09vnlxs9q5" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 leading-relaxed text-paper" data-id="element-198" data-mp="1z8o3ga7t3b6q">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-7" data-id="element-199" data-mp="2cyrmytfawqsh">
                <img src={testimonial.photo} alt={testimonial.name} className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-200" data-mp="2807yomd8j2wy" />
                <div data-id="element-201" data-mp="2i072y72mg740">
                  <p className="font-display text-base uppercase tracking-wide text-paper" data-id="element-202" data-mp="skhhg6wkscqw">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-paper-dim" data-id="element-203" data-mp="nmpp5bs0qom6">
                    {testimonial.role} — {testimonial.location}
                  </p>
                  <p className="mt-2 inline-block rounded-full bg-mint/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-mint" data-id="element-204" data-mp="1dbweybjcmngm">
                    {testimonial.result}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}